import styled from 'styled-components'
import { COLOR } from 'src/service/constant/color'
import { customMedia } from './common'

const SubTopWrap = styled.div`
  margin: 76px auto 0 auto;
  width: 100%;
  height: 230px;
  background: ${COLOR.gray10};
  min-width: 328px;
  ${customMedia.lessThan('tablet')`
  margin-top: 48px;
  height: 160px;
  width: 100%;
`}
  ${customMedia.lessThan('tablet_cut_line')`
    padding: 0 16px;
  `}
`
const SubTopContents = styled.div`
  display: flex;
  justify-content: space-between;
  height: 100%;
  width: 1100px;
  margin: 0 auto;
  >div{
    display: block;
    >p{
      font-family: NanumSquareNeoExtraBold, sans-serif;
      margin: 74px 0 10px 0;
      font-size: 36px;
      color: ${COLOR.black}
      line-height: 40px;
    }
    >span {
      font-size: 18px;
      font-family: NotoSansRegular, sans-serif;
      line-height: 26px;
      color: ${COLOR.gray50};
    }
  }
  >img{
    margin: 32.5px 124px 32.5px 0;
    display: flex;
    height: 165px;
  }
  ${customMedia.lessThan('tablet')`
   max-width:600px;
   width: 100%;
   >div{
    >p{
      margin: 51px 0 10px 0;  
      font-size: 24px;
      line-height: 27px;
    }
    >span{
      font-size: 14px;
      line-height: 20px;
    }
   }
   >img{
    display:none; 
   }
`}
  
`

export { SubTopWrap, SubTopContents }
